import activity from './locales/js/activity.nl.js';
import analytics from './locales/js/analytics.nl.js';
import announcement from './locales/js/announcement.nl.js';
import building from './locales/js/building.nl.js';
import button from './locales/js/button.nl.js';
import client from './locales/js/client.nl.js';
import company from './locales/js/company.nl.js';
import constants from './locales/js/constants.nl.js';
import contact from './locales/js/contact.nl.js';
import countries from './locales/js/countries.nl.js';
import customer from './locales/js/customer.nl.js';
import decision from './locales/js/decision.nl.js';
import decision_type from './locales/js/decision_type.nl.js';
import document from './locales/js/document.nl.js';
import dropzone from './locales/js/dropzone.nl.js';
import editor_ziggu from './locales/js/editor_ziggu.nl.js';
import employee from './locales/js/employee.nl.js';
import form from './locales/js/form.nl.js';
import inspiration from './locales/js/inspiration.nl.js';
import inspiration_list from './locales/js/inspiration_list.nl.js';
import installment from './locales/js/installment.nl.js';
import installment_term from './locales/js/installment_term.nl.js';
import integration from './locales/js/integration.nl.js';
import integration_error from './locales/js/integration_error.nl.js';
import issue from './locales/js/issue.nl.js';
import issue_category from './locales/js/issue_category.nl.js';
import issue_list from './locales/js/issue_list.nl.js';
import issue_status from './locales/js/issue_status.nl.js';
import lead from './locales/js/lead.nl.js';
import levels from './locales/js/levels.nl.js';
import lot from './locales/js/lot.nl.js';
import message from './locales/js/message.nl.js';
import milestone from './locales/js/milestone.nl.js';
import modal from './locales/js/modal.nl.js';
import navbar from './locales/js/navbar.nl.js';
import notification from './locales/js/notification.nl.js';
import pages from './locales/js/pages.nl.js';
import partner from './locales/js/partner.nl.js';
import phase from './locales/js/phase.nl.js';
import profile from './locales/js/profile.nl.js';
import project from './locales/js/project.nl.js';
import proposal from './locales/js/proposal.nl.js';
import question from './locales/js/question.nl.js';
import question_list from './locales/js/question_list.nl.js';
import reminder from './locales/js/reminder.nl.js';
import sales from './locales/js/sales.nl.js';
import select from './locales/js/select.nl.js';
import session from './locales/js/session.nl.js';
import signature from './locales/js/signature.nl.js';
import space from './locales/js/space.nl.js';
import subscription from './locales/js/subscription.nl.js';
import survey from './locales/js/survey.nl.js';
import survey_type from './locales/js/survey_type.nl.js';
import tenant from './locales/js/tenant.nl.js';
import ticket from './locales/js/ticket.nl.js';
import timestamp from './locales/js/timestamp.nl.js';
import toast from './locales/js/toast.nl.js';
import todo from './locales/js/todo.nl.js';
import todo_list from './locales/js/todo_list.nl.js';
import unit from './locales/js/unit.nl.js';
import upsell from './locales/js/upsell.nl.js';
import validation from './locales/js/validation.nl.js';
import window from './locales/js/window.nl.js';

export default {
  nl: {
    ...activity.nl,
    ...analytics.nl,
    ...announcement.nl,
    ...building.nl,
    ...button.nl,
    ...client.nl,
    ...company.nl,
    ...constants.nl,
    ...contact.nl,
    ...countries.nl,
    ...customer.nl,
    ...decision.nl,
    ...decision_type.nl,
    ...document.nl,
    ...dropzone.nl,
    ...editor_ziggu.nl,
    ...employee.nl,
    ...form.nl,
    ...inspiration.nl,
    ...inspiration_list.nl,
    ...installment.nl,
    ...installment_term.nl,
    ...integration.nl,
    ...integration_error.nl,
    ...issue.nl,
    ...issue_category.nl,
    ...issue_list.nl,
    ...issue_status.nl,
    ...lead.nl,
    ...levels.nl,
    ...lot.nl,
    ...message.nl,
    ...milestone.nl,
    ...modal.nl,
    ...navbar.nl,
    ...notification.nl,
    ...pages.nl,
    ...partner.nl,
    ...phase.nl,
    ...profile.nl,
    ...project.nl,
    ...proposal.nl,
    ...question.nl,
    ...question_list.nl,
    ...reminder.nl,
    ...sales.nl,
    ...select.nl,
    ...session.nl,
    ...signature.nl,
    ...space.nl,
    ...subscription.nl,
    ...survey.nl,
    ...survey_type.nl,
    ...tenant.nl,
    ...ticket.nl,
    ...timestamp.nl,
    ...toast.nl,
    ...todo.nl,
    ...todo_list.nl,
    ...unit.nl,
    ...upsell.nl,
    ...validation.nl,
    ...window.nl,
  },
};
